import type { ContactSubmissionPayload, SubscribeSubmissionPayload } from './types'

const FORM_SUBMIT_URL =
  process.env.NEXT_PUBLIC_FORM_SUBMIT_URL?.replace(/\/$/, '') ?? ''

async function postToApi(
  payload: ContactSubmissionPayload | SubscribeSubmissionPayload,
): Promise<void> {
  if (!FORM_SUBMIT_URL) {
    throw new Error(
      'NEXT_PUBLIC_FORM_SUBMIT_URL is not set. Add it to .env.',
    )
  }

  const formToken =
    process.env.NEXT_PUBLIC_CONTACT_API_TOKEN || process.env.CONTACT_API_TOKEN
  const headers: HeadersInit = { 'Content-Type': 'application/json' }
  if (formToken) headers['Authorization'] = `Bearer ${formToken}`

  const res = await fetch(FORM_SUBMIT_URL, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
  })

  if (!res.ok) {
    let message = `Server error: ${res.status}`
    try {
      const body = (await res.json()) as {
        error?: { message?: string }
        message?: string
      }
      const apiMessage = body?.error?.message ?? body?.message
      if (apiMessage) message = apiMessage
    } catch {
      // ignore JSON parse errors
    }
    if (res.status === 400 && /email/i.test(message)) {
      message = 'Please enter a valid email address.'
    }
    throw new Error(message)
  }
}

export async function submitContactForm(payload: ContactSubmissionPayload): Promise<void> {
  return postToApi(payload)
}

export async function submitSubscribeForm(email: string, recaptchaToken: string): Promise<void> {
  return postToApi({
    data: {
      Email: email,
      service: 'subscribe',
      recaptchaToken,
    },
  })
}
